import React, { useState } from 'react'
import GameManager from '../../../../../GameManager';
import Tools from '../../../../../Misc/Tools';
import { JSXUIData, JSXUIDebugTemplate } from '../../../../../UI/JsxUiManager';
import { UI } from '../../../../../UI/UiManager';
import CoreGeneralButton from '../../core-general-button';
import CoreLandingPage from '../../core-landing-page';
import CoreDebugSideMenu from './core-debug-dropdown-window';

import "./core-debug-landing-page-window.css"

const CoreDebugLandingPageWindow = (props: CoreDebugLandingPageWindowConfig) => {
	return (
		<div className='core-debug-ui-landing-page-window core-debug-ui-general-window'>
			<div className='core-debug-ui-general-window' style={{ width: '100%', height: '100%' }}>
				<CoreLandingPage></CoreLandingPage>
			</div>
			<div style={{
				position: 'absolute',
				top: '850px',
				left: '10px'
			}}>
				<CoreDebugSideMenu onIndexChanged={(indx: number) => {
				}} hideDropdown={true} codeSnippet={`<CoreLandingPage></CoreLandingPage>`}></CoreDebugSideMenu>

			</div>
			<div className='core-debug-ui-back-bttn'>
				<CoreGeneralButton width='100%'
					height='100%'
					onClick={props.onBackToMainWindowClicked}
					onRenderContent={() => {
						return (
							<p className='small-text center-element'>{'Back to Main Window'}</p>
						)
					}}
					isSelected={false}
					isDisabled={false}
					ariaLabel={'Back to Main Window'}></CoreGeneralButton>
			</div>
		</div>
	);
};

export interface CoreDebugLandingPageWindowConfig {
	showWindowBackground: boolean;
	gameManager: GameManager;
	onBackToMainWindowClicked: () => void;
	onSpawned: () => void;
	setForceUpdate: () => void;
}

export default CoreDebugLandingPageWindow;